// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Address proof front and back and Noc Documents fetch values
// MODIFIED DATE : 30-07-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import MemberMandatoryAccessActionTypes from './member-mandatory-access.types';
import {
	fetchMandatoryMemberAccessType,
	updateMandatoryMemberAccessType,
} from './member-mandatory-access.service';
import {
	fetchMemberMandatoryAccessSuccess,
	fetchMemberMandatoryAccessFailure,
	fetchMemberMandatoryAccessResponseChanged,
	updateMemberMandatoryAccessSuccess,
	updateMemberMandatoryAccessFailure,
	updateMemberMandatoryAccessResponseChanged,
} from './member-mandatory-access.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START FETCH MemberMandatory DETAILS LIST  ******************** */
export function* fetchMemberMandatoryAccessList({ payload }: any) {
	try {
		const key = 'MemberMandatoryAccessKey';
		const { companyID, mandatoryMode, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			MandatoryMode: mandatoryMode,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchMandatoryMemberAccessType, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberMandatoryAccessFailure(responseData.data));
		} else {
			yield put(fetchMemberMandatoryAccessSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberMandatoryAccessFailure(error));
	}
}

export function* resetFetchListMemberMandatoryAccessResponse() {
	yield put(fetchMemberMandatoryAccessResponseChanged());
}

export function* onFetchListMemberMandatoryAccess() {
	yield takeLatest(
		MemberMandatoryAccessActionTypes.FETCH_MEMBER_MANDATORY_ACCESS_START,
		fetchMemberMandatoryAccessList,
	);
}

export function* onFetchListMemberMandatoryAccessResponseReset() {
	yield takeLatest(
		MemberMandatoryAccessActionTypes.FETCH_MEMBER_MANDATORY_ACCESS_RESPONSE_RESET,
		resetFetchListMemberMandatoryAccessResponse,
	);
}

/** *********************  END FETCH MemberMandatory DETAILS LIST ******************** */

/** *********************  START UPDATE MemberMandatory DETAILS LIST  ******************** */
export function* updateMemberMandatoryAccessList({ payload }: any) {
	try {
		const key = 'MemberMandatoryUpdateKey';
		const {
			companyID,
			databaseName,
			userID,
			userAccessBranchID,
			userName,
			mandatoryMode,
			aadharNumber,
			aadharPhoto,
			panCard,
			panCardFrontImage,
			panCardBackImage,
			idProof1,
			idProof1Image,
			idProof2,
			idProof2Image,
			gender,
			photo,
			signature,
			name,
			dOB,
			age,
			phone,
			altPhone,
			marritialStatus,
			fatherName,
			motherName,
			spouseName,
			spouseDOB,
			doorNo,
			streetAddress,
			country,
			state,
			city,
			pinCode,
			district,
			village,
			currentDoorNo,
			currentAddress,
			currentAddressSince,
			currentAddressCountry,
			currentAddressState,
			currentAddressCity,
			currentAddressPin,
			currentAddressDistrict,
			currentAddressLocalArea,
			citizen,
			familyType,
			familyCount,
			familyMemberName,
			familyMemberAadhar,
			familyMemberGender,
			familyMemberDOB,
			familyMemberAge,
			familyMemberRelationship,
			familyMemberEducation,
			familyMemberOccupation,
			familyTotalIncome,
			familyMonthlyIncode,
			familyMonthlyExpense,
			familyMontlyExtraSpend,
			dOJ,
			economicActivity,
			economicActivityType,
			center,
			applicationAmount,
			annualIncome,
			monthlyIncome,
			otherIncome,
			preferredLanguage,
			disability,
			bloodGroup,
			identification,
			educationQualification,
			religion,
			caste,
			emailID,
			ruralUrban,
			landValue,
			nomineeRelationship,
			nomineeName,
			nomineeGender,
			nomineeFatherName,
			nomineeDOB,
			nomineeAge,
			nomineeAadhar,
			nomineeAadharPhoto,
			nomineeIDProff,
			nomineeIDProffImage,
			nomineePhoneNumber,
			nomineeCurrentDoorNo,
			nomineeCurrentAddress,
			nomineePhoto,
			houseType,
			durationOfStay,
			noOfRoom,
			facilityType,
			agricultureLand,
			liveStock,
			assetType,
			bankAccNumber,
			reBankAccNUmber,
			accHolderName,
			ifscCode,
			bankName,
			bankBranchName,
			bankTransaction,
			rbiStatus,
			accountType,
			needMemberAgeLimit,
			needNomineeAgeLimit,
			needSpouseAgeLimit,
			needFamilyAgeLimit,
			needCoApplicantAgeLimit,
			memberMinAge,
			memberMaxAge,
			nomineeMinAge,
			nomineeMaxAge,
			spouseMinAge,
			spouseMaxAge,
			familyMinAge,
			familyMaxAge,
			coApplicantMinAge,
			coApplicantMaxAge,
			coApplicantName,
			coApplicantDOB,
			coApplicantRelationship,
			coApplicantOccupation,
			coApplicantPhoneNumber,
			coApplicantMonthlyIncome,
			coApplicantAadharNumber,
			coApplicantIDProof,
			coApplicantIDProofNumber,
			coApplicantAddressProof,
			coApplicantAddressProofNumber,
			coApplicantAadharFront,
			coApplicantAadharBack,
			coApplicantIDProofFront,
			coApplicantIDProofBack,
			coApplicantAddressProofFront,
			coApplicantAddressProofBack,
			coApplicantPhoto,
			coApplicantTogetherPhoto,
			coApplicantAgreement,
			aadharBackPhoto,
			idProof1BackImage,
			idProof2BackImage,
			nomineeAadharBackPhoto,
			nomineeIDProffBackImage,
			houseImage1,
			houseImage2,
			houseImage3,
			houseImage4,
			houseImage5,
			passbookImage,
			coApplicantDoorNumber,
			coApplicantStreet,
			coApplicantCity,
			coApplicantDistrict,
			coApplicantState,
			coApplicantCountry,
			coApplicantPincode,
			coApplicantMaritalStatus,
			coApplicantRelationShipWithMember,
			coApplicantGender,
			coApplicantLoanAppliedAmount,
			nocDocument1,
			nocDocument2,
			nocDocument3,
			needCenterOnCrif,
			needFamilyMemberChildrenCount,
			needPhoneAvailability,
			productType,
			addressprooffront,
			addressproofback,
			noOfFlors,
			familyMemberSecDept,
			familyMemberModeOfEducation,
			familyMemberSchoolCollege,
			residentialPostOffice,
			currentAddressPostOffice,
			coApplicantPostOffice,

			// Business Loan Fields
			businessLoanBusinessName,
			businessLoanBusinessFormat,
			businessLoanConstitution,
			businessLoanIndustry,
			businessLoanSubIndustry,
			businessLoanYearOfIncorporation,
			businessLoanDateOfIncorporation,
			businessLoanNoOfDirectors,
			businessLoanNoOfEmployee,
			businessLoanNoOfBranch,
			businessLoanPartiesAadhar,
			businessLoanPartnerPhoneNo,

			// Business Registration
			businessLoanCinNumber,
			businessLoanPanNumber,
			businessLoanBusinessaadharNumber,
			businessLoanPropertyType,
			businessLoanPropertyStatus,
			businessLoanGstNumber,
			businessLoanLeiNumber,
			businessLoanNoOfFlors,

			// Loan Details
			businessLoanRentalCost,
			businessLoanPurposeOfLoan,
			businessLoanRequestedAmount,
			businessLoanBusinessExperience,
			businessLoanAverageMonthlyTurnover,
			businessLoanExpectedFestivalSale,
			businessLoanStockValue,
			businessLoanSurveyNumber,
			businessLoanSquareFeet,
			businessLoanHeadOfficeZip,
			businessLoanHeadOfficeCountry,
			businessLoanHeadOfficeState,
			businessLoanHeadOfficePostOffice,

			// Address Details
			businessLoanHeadOfficeAddressLine1,
			businessLoanHeadOfficeAddressLine2,
			businessLoanRegisterOfficeZip,
			businessLoanRegisterOfficeCountry,
			businessLoanRegisterOfficeState,
			businessLoanRegisterOfficePostOffice,
			businessLoanRegisterOfficeAddressLine1,
			businessLoanRegisterOfficeAddressLine2,

			// Contact Persons
			businessLoanContactPerson1Name,
			businessLoanContactPerson1Title,
			businessLoanContactPerson1Phone,
			businessLoanContactPerson1Email,
			businessLoanContactPerson2Name,
			businessLoanContactPerson2Title,
			businessLoanContactPerson2Phone,
			businessLoanContactPerson2Email,
			businessLoanContactPerson3Name,
			businessLoanContactPerson3Title,
			businessLoanContactPerson3Phone,
			businessLoanContactPerson3Email,

			// Document URLs
			businessLoanCinRegisterationURl,
			businessLoanPanUrl,
			businessLoanGstImage,

			// System Fields
			businessLoanAadharImageFront,
			businessLoanAadharImageBack,

			// Borrower Section
			businessLoanBorrowerImage,
			businessLoanPartiesName,
			PartnerBusinessLoanMobileNumber,
			businessLoanPartiesDOB,
			businessLoanPartiesDOBLimit,
			businessLoanPartiesEmailID,
			businessLoanPartiesType,
			businessLoanPartiesPhoto,
			businessLoanPartiesProfile,
			businessLoanBusinessPartiesaadharNumber,
			businessLoanVoterIDNumber,
			businessLoanRationcardNumber,
			businessLoanZipCode,
			businessLoanStateID,

			// Borrower Address
			businessLoanAddressLine1,
			businessLoanAddressLine2,
			businessLoanReferenceCityID,
			businessLoanCoBarPostoffice,

			// Partner Details
			businessLoanPartnerName,
			businessLoanMobileNumber,
			businessLoanSharePrecentage,
			businessLoanTinNumber,
			businessLoanPanCard,
			businessLoanPartnerPhoto,
			businessLoanPartnerCity,
			businessLoanPartnerState,
			businessLoanPartnerZip,
			businessLoanPartnerCountry,

			// Reference 1
			businessLoanRef1Name,
			businessLoanRef1MobileNumber,
			businessLoanRef1Relationship,
			businessLoanRef1AddressLine1,
			businessLoanRef1AddressLine2,
			businessLoanRef1ZipCode,
			businessLoanRef1StateID,
			businessLoanRef1CityID,

			// Reference 2
			businessLoanRef2Name,
			businessLoanRef2MobileNumber,
			businessLoanRef2Relationship,
			businessLoanRef2AddressLine1,
			businessLoanRef2AddressLine2,
			businessLoanRef2StateID,
			businessLoanRef2CityID,
			businessLoanRef2ZipCode,

			// Business Bank
			businessLoanBankIfscCode,
			businessLoanBankName,
			businessLoanBankBranch,
			businessLoanStatementFrom,
			businessLoanStatementTill,
			businessLoanStatementPath,

			// Business Proof
			businessLoanProofName,
			businessLoanProofDocumentType,
			businessLoanProofDocumentUrl,

			// Business Verification
			businessLoanVerificationType,
			businessLoanVerificationPhotoPath,

			//Auto loan data
			autoLoanMobileNumber,
			autoLoanFullName,
			autoLoanGender,
			autoLoanFatherNameHusbandName,
			autoLoanDob,
			autoLoanAadharNumber,
			autoLoanPanCard,
			autoLoanMarritialStatus,
			autoLoanHouseType,
			autoLoanDurationOfStay,
			autoLoanEducationQualification,

			autoPermenentAddressPrsonalAddress,
			autoPermenentAddressPrsonalHouseNo,
			autoPermenentAddressPrsonalPostOffice,
			autoPermenentAddressPrsonalCity,
			autoPermenentAddressPrsonalDistrict,
			autoPermenentAddressPrsonalState,
			autoPermenentAddressPrsonalCountry,
			autoPermenentAddressPrsonalPincode,

			autoCurrentAddressAddress,
			autoCurrentAddressHouseNo,
			autoCurrentAddressPostOffice,
			autoCurrentAddressCity,
			autoCurrentAddressDistrict,
			autoCurrentAddressState,
			autoCurrentAddressCountry,
			autoCurrentAddressPincode,

			autoLoanBankAccNumber,
			autoLoanReBankAccNUmber,
			autoLoanAccHolderName,
			autoLoanIfscCode,
			autoLoanBankName,
			autoLoanBankBranchName,

			autoLoanIdProofFront,
			autoLoanIdProofBack,
			autoLoanHouseImage1,
			autoLoanHouseImage2,
			autoLoanAddressProofFront,
			autoLoanAddressProofBack,
			autoLoanPhoto,
			autoLoanPermanentAddress,
			autoLoanCurrentAddress,

			autoCoapplicantName,
			autoCoapplicantMobileNo,
			autoCoapplicantDOB,
			autoCoapplicantGender,
			autoCoapplicantRelationWithMember,
			autoCoapplicantAddress,
			autoCoapplicantDoorNo,
			autoCoapplicantCity,
			autoCoapplicantDistrct,
			autoCoapplicantState,
			autoCoapplicantCountry,
			autoCoapplicantPincode,
			autoCoapplicantMemberImg,
			autoCoapplicantAadharFrontImg,
			autoCoapplicantAadharBackImg,
			autoCoapplicantHouseEbBillImg,
			autoCoapplicantHouseGasBillImg,
			autoCoapplicantAddressProofFrontImg,
			autoCoapplicantAddressProofBackImg,
			autoLoanBusinessCompany,
			autoLoanBusinessDesignation,
			autoLoanInsuranceFee,
			autoLoanInsurancePeriod,
			autoLoanMemberType,
			autoLoanCompanyName,
			autoLoanDesignation,
			autoLoanYearsWorking,
			autoLoanIncomeType,
			autoLoanBusinessIncome,
			autoLoanPaySlipImage,
			autoLoanEmployeeIdCardImage,
			autoLoanBusinessPassBook,
			autoLoanBusinessPremises,
			autoLoanApproximateSqft,
			autoLoanRegisteredSince,
			autoLoanNameOfBoard,
			autoLoanBusinessStock,
			autoLoanBusinessAddress,
			autoLoanBusinessBoard,
			autoLoanShopOrCompany,
			autovehicleInsurancePeriod,
			autoLoanAltPhone,
			autoBusinessPremises,
			autoNameOfBoard,
			autoBankStatementImg,
			autoPaySlipImg,
			autoApproximateSqft,

			autoLoanMakerName,
			autoLoanYearOfManufacture,
			autoLoanOwnershipType,
			autoLoanVehicleType,
			autoLoanVehicleName,
			autoLoanVehicleCC,
			autoLoanVehicleColor,
			autoLoanVehicleCondition,
			autoLoanNumberOfOwnership,
			autoLoanVehicleKeySurrender,
			autoLoanRcBookSurrender,
			autoLoanRcBookSurrenderType,
			autoLoanRegistrationState,
			autoLoanRegistrationCity,
			autoLoanRegistrationDate,
			autoLoanRegistrationNumber,
			autoLoanEngineNumber,
			autoLoanChassisNumber,
			autoLoanInsuranceType,

			autoLoanVehicleNumberPlateImg,
			autoLoanVehicleNumberFrontImg,
			autoLoanVehicleLeftSideImg,
			autoLoanVehicleRighitSideImg,
			autoLoanVehicleBackSideImg,
			autoLoanVehicleFrontSideImg,
			autoLoanVehicleFrontSidePlateImg,
			autoLoanVehicleRCBookFrontImg,
			autoLoanVehicleRCBookBackImg,
			autoLoanVehicleKeyImg,
			autoLoanVehicleKMReadingImg,
			autoChassisNumberImage,
			autoEngineNumberImage,
			autoNOCImage1,
			autoNOCImage2,
			autoTOImage1,
			autoTOImage2,
		} = payload;
		const jsonData = {
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
			MandatoryMode: mandatoryMode,
			AadharNumber: aadharNumber,
			AadharPhoto: aadharPhoto,
			panCard: panCard,
			PanCardFrontImage: panCardFrontImage,
			PanCardBackImage: panCardBackImage,
			IDProof1: idProof1,
			IDProof1Image: idProof1Image,
			IDProof2: idProof2,
			IDProof2Image: idProof2Image,
			Gender: gender,
			Photo: photo,
			Signature: signature,
			Name: name,
			DOB: dOB,
			Age: age,
			Phone: phone,
			AltPhone: altPhone,
			MarritialStatus: marritialStatus,
			FatherName: fatherName,
			MotherName: motherName,
			SpouseName: spouseName,
			SpouseDOB: spouseDOB,
			DoorNo: doorNo,
			StreetAddress: streetAddress,
			Country: country,
			State: state,
			City: city,
			PinCode: pinCode,
			District: district,
			Village: village,
			CurrentDoorNo: currentDoorNo,
			CurrentAddress: currentAddress,
			CurrentAddressSince: currentAddressSince,
			CurrentAddressCountry: currentAddressCountry,
			CurrentAddressState: currentAddressState,
			CurrentAddressCity: currentAddressCity,
			CurrentAddressPin: currentAddressPin,
			CurrentAddressDistrict: currentAddressDistrict,
			CurrentAddressLocalArea: currentAddressLocalArea,
			Citizen: citizen,
			FamilyType: familyType,
			FamilyCount: familyCount,
			FamilyMemberName: familyMemberName,
			FamilyMemberAadhar: familyMemberAadhar,
			FamilyMemberGender: familyMemberGender,
			FamilyMemberDOB: familyMemberDOB,
			FamilyMemberAge: familyMemberAge,
			FamilyMemberRelationship: familyMemberRelationship,
			FamilyMemberEducation: familyMemberEducation,
			FamilyMemberOccupation: familyMemberOccupation,
			FamilyTotalIncome: familyTotalIncome,
			FamilyMonthlyIncode: familyMonthlyIncode,
			FamilyMonthlyExpense: familyMonthlyExpense,
			FamilyMontlyExtraSpend: familyMontlyExtraSpend,
			DOJ: dOJ,
			EconomicActivity: economicActivity,
			EconomicActivityType: economicActivityType,
			Center: center,
			ApplicationAmount: applicationAmount,
			AnnualIncome: annualIncome,
			MonthlyIncome: monthlyIncome,
			OtherIncome: otherIncome,
			preferredLanguage: preferredLanguage,
			Disability: disability,
			BloodGroup: bloodGroup,
			Identification: identification,
			EducationQualification: educationQualification,
			Religion: religion,
			Caste: caste,
			EmailID: emailID,
			RuralUrban: ruralUrban,
			LandValue: landValue,
			NomineeRelationship: nomineeRelationship,
			NomineeName: nomineeName,
			NomineeGender: nomineeGender,
			NomineeFatherName: nomineeFatherName,
			NomineeDOB: nomineeDOB,
			NomineeAge: nomineeAge,
			NomineeAadhar: nomineeAadhar,
			NomineeAadharPhoto: nomineeAadharPhoto,
			NomineeIDProff: nomineeIDProff,
			NomineeIDProffImage: nomineeIDProffImage,
			NomineePhoneNumber: nomineePhoneNumber,
			NomineeCurrentDoorNo: nomineeCurrentDoorNo,
			NomineeCurrentAddress: nomineeCurrentAddress,
			NomineePhoto: nomineePhoto,
			HouseType: houseType,
			DurationOfStay: durationOfStay,
			NoOfRoom: noOfRoom,
			FacilityType: facilityType,
			AgricultureLand: agricultureLand,
			LiveStock: liveStock,
			AssetType: assetType,
			BankAccNumber: bankAccNumber,
			ReBankAccNUmber: reBankAccNUmber,
			AccHolderName: accHolderName,
			IFSCCode: ifscCode,
			BankName: bankName,
			BankBranchName: bankBranchName,
			BankTransaction: bankTransaction,
			RBIStatus: rbiStatus,
			AccountType: accountType,
			NeedMemberAgeLimit: needMemberAgeLimit,
			NeedNomineeAgeLimit: needNomineeAgeLimit,
			NeedSpouseAgeLimit: needSpouseAgeLimit,
			NeedFamilyAgeLimit: needFamilyAgeLimit,
			NeedCoApplicantAgeLimit: needCoApplicantAgeLimit,
			MemberMinAge: memberMinAge,
			MemberMaxAge: memberMaxAge,
			NomineeMinAge: nomineeMinAge,
			NomineeMaxAge: nomineeMaxAge,
			SpouseMinAge: spouseMinAge,
			SpouseMaxAge: spouseMaxAge,
			FamilyMinAge: familyMinAge,
			FamilyMaxAge: familyMaxAge,
			CoApplicantMinAge: coApplicantMinAge,
			CoApplicantMaxAge: coApplicantMaxAge,
			CoApplicantName: coApplicantName,
			CoApplicantDOB: coApplicantDOB,
			CoApplicantRelationship: coApplicantRelationship,
			CoApplicantOccupation: coApplicantOccupation,
			CoApplicantPhoneNumber: coApplicantPhoneNumber,
			CoApplicantMonthlyIncome: coApplicantMonthlyIncome,
			CoApplicantAadharNumber: coApplicantAadharNumber,
			CoApplicantIDProof: coApplicantIDProof,
			CoApplicantIDProofNumber: coApplicantIDProofNumber,
			CoApplicantAddressProof: coApplicantAddressProof,
			CoApplicantAddressProofNumber: coApplicantAddressProofNumber,
			CoApplicantAadharFront: coApplicantAadharFront,
			CoApplicantAadharBack: coApplicantAadharBack,
			CoApplicantIDProofFront: coApplicantIDProofFront,
			CoApplicantIDProofBack: coApplicantIDProofBack,
			CoApplicantAddressProofFront: coApplicantAddressProofFront,
			CoApplicantAddressProofBack: coApplicantAddressProofBack,
			CoApplicantPhoto: coApplicantPhoto,
			CoApplicantTogetherPhoto: coApplicantTogetherPhoto,
			CoApplicantAgreement: coApplicantAgreement,
			AadharBackPhoto: aadharBackPhoto,
			IDProof1BackImage: idProof1BackImage,
			IDProof2BackImage: idProof2BackImage,
			NomineeAadharBackPhoto: nomineeAadharBackPhoto,
			NomineeIDProffBackImage: nomineeIDProffBackImage,
			HouseImage1: houseImage1,
			HouseImage2: houseImage2,
			HouseImage3: houseImage3,
			HouseImage4: houseImage4,
			HouseImage5: houseImage5,
			PassbookImage: passbookImage,
			CoApplicantDoorNumber: coApplicantDoorNumber,
			CoApplicantStreet: coApplicantStreet,
			CoApplicantCity: coApplicantCity,
			CoApplicantDistrict: coApplicantDistrict,
			CoApplicantState: coApplicantState,
			CoApplicantCountry: coApplicantCountry,
			CoApplicantPincode: coApplicantPincode,
			CoApplicantMaritalStatus: coApplicantMaritalStatus,
			CoApplicantRelationShipWithMember: coApplicantRelationShipWithMember,
			CoApplicantGender: coApplicantGender,
			CoApplicantLoanAppliedAmount: coApplicantLoanAppliedAmount,
			NOCDocument1: nocDocument1,
			NOCDocument2: nocDocument2,
			NOCDocument3: nocDocument3,
			NeedCenterOnCrif: needCenterOnCrif,
			NeedFamilyMemberChildrenCount: needFamilyMemberChildrenCount,
			NeedPhoneAvailability: needPhoneAvailability,
			ProductType: productType,
			AddressProofFront: addressprooffront,
			AddressProofBack: addressproofback,
			familyMemberSecDept: familyMemberSecDept,
			familyMemberModeOfEducation: familyMemberModeOfEducation,
			familyMemberSchoolCollege: familyMemberSchoolCollege,
			residentialPostOffice: residentialPostOffice,
			currentAddressPostOffice: currentAddressPostOffice,
			coApplicantPostOffice: coApplicantPostOffice,

			//business data

			BusinessLoanBusinessName: businessLoanBusinessName,
			BusinessLoanBusinessFormat: businessLoanBusinessFormat,
			BusinessLoanConstitution: businessLoanConstitution,
			BusinessLoanIndustry: businessLoanIndustry,
			BusinessLoanSubIndustry: businessLoanSubIndustry,
			BusinessLoanYearOfIncorporation: businessLoanYearOfIncorporation,
			BusinessLoanDateOfIncorporation: businessLoanDateOfIncorporation,
			BusinessLoanNoOfDirectors: businessLoanNoOfDirectors,
			BusinessLoanNoOfEmployee: businessLoanNoOfEmployee,
			BusinessLoanNoOfBranch: businessLoanNoOfBranch,

			// Business Registration
			BusinessLoanCinNumber: businessLoanCinNumber,
			BusinessLoanPanNumber: businessLoanPanNumber,
			BusinessLoanBusinessaadharNumber: businessLoanBusinessaadharNumber,
			BusinessLoanPropertyType: businessLoanPropertyType,
			BusinessLoanPropertyStatus: businessLoanPropertyStatus,
			BusinessLoanGstNumber: businessLoanGstNumber,
			BusinessLoanLeiNumber: businessLoanLeiNumber,
			BusinessLoanNoOfFlors: businessLoanNoOfFlors,

			// Loan Details
			BusinessLoanRentalCost: businessLoanRentalCost,
			BusinessLoanPurposeOfLoan: businessLoanPurposeOfLoan,
			BusinessLoanRequestedAmount: businessLoanRequestedAmount,
			BusinessLoanBusinessExperience: businessLoanBusinessExperience,
			BusinessLoanAverageMonthlyTurnover: businessLoanAverageMonthlyTurnover,
			BusinessLoanExpectedFestivalSale: businessLoanExpectedFestivalSale,
			BusinessLoanStockValue: businessLoanStockValue,
			BusinessLoanSurveyNumber: businessLoanSurveyNumber,
			BusinessLoanSquareFeet: businessLoanSquareFeet,
			BusinessLoanHeadOfficeZip: businessLoanHeadOfficeZip,
			BusinessLoanHeadOfficeCountry: businessLoanHeadOfficeCountry,
			BusinessLoanHeadOfficeState: businessLoanHeadOfficeState,
			BusinessLoanHeadOfficePostOffice: businessLoanHeadOfficePostOffice,

			// Address Details
			BusinessLoanHeadOfficeAddressLine1: businessLoanHeadOfficeAddressLine1,
			BusinessLoanHeadOfficeAddressLine2: businessLoanHeadOfficeAddressLine2,
			BusinessLoanRegisterOfficeZip: businessLoanRegisterOfficeZip,
			BusinessLoanRegisterOfficeCountry: businessLoanRegisterOfficeCountry,
			BusinessLoanRegisterOfficeState: businessLoanRegisterOfficeState,
			BusinessLoanRegisterOfficePostOffice: businessLoanRegisterOfficePostOffice,
			BusinessLoanRegisterOfficeAddressLine1: businessLoanRegisterOfficeAddressLine1,
			BusinessLoanRegisterOfficeAddressLine2: businessLoanRegisterOfficeAddressLine2,

			// Contact Persons
			BusinessLoanContactPerson1Name: businessLoanContactPerson1Name,
			BusinessLoanContactPerson1Title: businessLoanContactPerson1Title,
			BusinessLoanContactPerson1Phone: businessLoanContactPerson1Phone,
			BusinessLoanContactPerson1Email: businessLoanContactPerson1Email,
			BusinessLoanContactPerson2Name: businessLoanContactPerson2Name,
			BusinessLoanContactPerson2Title: businessLoanContactPerson2Title,
			BusinessLoanContactPerson2Phone: businessLoanContactPerson2Phone,
			BusinessLoanContactPerson2Email: businessLoanContactPerson2Email,
			BusinessLoanContactPerson3Name: businessLoanContactPerson3Name,
			BusinessLoanContactPerson3Title: businessLoanContactPerson3Title,
			BusinessLoanContactPerson3Phone: businessLoanContactPerson3Phone,
			BusinessLoanContactPerson3Email: businessLoanContactPerson3Email,

			// Document URLs
			BusinessLoanCinRegisterationURl: businessLoanCinRegisterationURl,
			BusinessLoanPanUrl: businessLoanPanUrl,
			BusinessLoanGstImage: businessLoanGstImage,

			// System Fields
			BusinessLoanAadharImageFront: businessLoanAadharImageFront,
			BusinessLoanAadharImageBack: businessLoanAadharImageBack,

			// Borrower Section
			BusinessLoanBorrowerImage: businessLoanBorrowerImage,
			BusinessLoanPartiesName: businessLoanPartiesName,
			PartnerBusinessLoanMobileNumber: PartnerBusinessLoanMobileNumber,
			BusinessLoanPartiesDOB: businessLoanPartiesDOB,
			BusinessLoanPartiesDOBLimit: businessLoanPartiesDOBLimit,
			BusinessLoanPartiesEmailID: businessLoanPartiesEmailID,
			BusinessLoanPartiesType: businessLoanPartiesType,
			BusinessLoanPartiesPhoto: businessLoanPartiesPhoto,
			BusinessLoanPartiesProfile: businessLoanPartiesProfile,
			BusinessLoanBusinessPartiesaadharNumber: businessLoanBusinessPartiesaadharNumber,
			BusinessLoanVoterIDNumber: businessLoanVoterIDNumber,
			BusinessLoanRationcardNumber: businessLoanRationcardNumber,
			BusinessLoanZipCode: businessLoanZipCode,
			BusinessLoanStateID: businessLoanStateID,

			// Borrower Address
			BusinessLoanAddressLine1: businessLoanAddressLine1,
			BusinessLoanAddressLine2: businessLoanAddressLine2,
			BusinessLoanReferenceCityID: businessLoanReferenceCityID,
			BusinessLoanCoBarPostoffice: businessLoanCoBarPostoffice,

			// Partner Details
			BusinessLoanPartnerName: businessLoanPartnerName,
			BusinessLoanMobileNumber: businessLoanMobileNumber,
			BusinessLoanSharePrecentage: businessLoanSharePrecentage,
			BusinessLoanTinNumber: businessLoanTinNumber,
			BusinessLoanPanCard: businessLoanPanCard,
			BusinessLoanPartnerPhoto: businessLoanPartnerPhoto,
			BusinessLoanPartnerCity: businessLoanPartnerCity,
			BusinessLoanPartnerState: businessLoanPartnerState,
			BusinessLoanPartnerZip: businessLoanPartnerZip,
			BusinessLoanPartnerCountry: businessLoanPartnerCountry,

			// Reference 1
			BusinessLoanRef1Name: businessLoanRef1Name,
			BusinessLoanRef1MobileNumber: businessLoanRef1MobileNumber,
			BusinessLoanRef1Relationship: businessLoanRef1Relationship,
			BusinessLoanRef1AddressLine1: businessLoanRef1AddressLine1,
			BusinessLoanRef1AddressLine2: businessLoanRef1AddressLine2,
			BusinessLoanRef1ZipCode: businessLoanRef1ZipCode,
			BusinessLoanRef1StateID: businessLoanRef1StateID,
			BusinessLoanRef1CityID: businessLoanRef1CityID,

			// Reference 2
			BusinessLoanRef2Name: businessLoanRef2Name,
			BusinessLoanRef2MobileNumber: businessLoanRef2MobileNumber,
			BusinessLoanRef2Relationship: businessLoanRef2Relationship,
			BusinessLoanRef2AddressLine1: businessLoanRef2AddressLine1,
			BusinessLoanRef2AddressLine2: businessLoanRef2AddressLine2,
			BusinessLoanRef2StateID: businessLoanRef2StateID,
			BusinessLoanRef2CityID: businessLoanRef2CityID,
			BusinessLoanRef2ZipCode: businessLoanRef2ZipCode,

			// Business Bank
			BusinessLoanBankIfscCode: businessLoanBankIfscCode,
			BusinessLoanBankName: businessLoanBankName,
			BusinessLoanBankBranch: businessLoanBankBranch,
			BusinessLoanStatementFrom: businessLoanStatementFrom,
			BusinessLoanStatementTill: businessLoanStatementTill,
			BusinessLoanStatementPath: businessLoanStatementPath,

			// Business Proof
			BusinessLoanProofName: businessLoanProofName,
			BusinessLoanProofDocumentType: businessLoanProofDocumentType,
			BusinessLoanProofDocumentUrl: businessLoanProofDocumentUrl,

			// Business Verification
			BusinessLoanVerificationType: businessLoanVerificationType,
			BusinessLoanVerificationPhotoPath: businessLoanVerificationPhotoPath,
			BusinessPartiesAadhar: businessLoanPartiesAadhar,
			BusinessLoanPartnerPhoneNo: businessLoanPartnerPhoneNo,

			//Auto Loan Data

			AutoLoanMobileNumber: autoLoanMobileNumber,
			AutoLoanFullName: autoLoanFullName,
			AutoLoanGender: autoLoanGender,
			AutoLoanFatherNameHusbandName: autoLoanFatherNameHusbandName,
			AutoLoanDob: autoLoanDob,
			AutoLoanAadharNumber: autoLoanAadharNumber,
			AutoLoanPanCard: autoLoanPanCard,
			AutoLoanMarritialStatus: autoLoanMarritialStatus,
			AutoLoanHouseType: autoLoanHouseType,
			AutoLoanDurationOfStay: autoLoanDurationOfStay,
			AutoLoanEducationQualification: autoLoanEducationQualification,

			AutoPermenentAddressPrsonalAddress: autoPermenentAddressPrsonalAddress,
			AutoPermenentAddressPrsonalHouseNo: autoPermenentAddressPrsonalHouseNo,
			AutoPermenentAddressPrsonalPostOffice: autoPermenentAddressPrsonalPostOffice,
			AutoPermenentAddressPrsonalCity: autoPermenentAddressPrsonalCity,
			AutoPermenentAddressPrsonalDistrict: autoPermenentAddressPrsonalDistrict,
			AutoPermenentAddressPrsonalState: autoPermenentAddressPrsonalState,
			AutoPermenentAddressPrsonalCountry: autoPermenentAddressPrsonalCountry,
			AutoPermenentAddressPrsonalPincode: autoPermenentAddressPrsonalPincode,

			AutoCurrentAddressAddress: autoCurrentAddressAddress,
			AutoCurrentAddressHouseNo: autoCurrentAddressHouseNo,
			AutoCurrentAddressPostOffice: autoCurrentAddressPostOffice,
			AutoCurrentAddressCity: autoCurrentAddressCity,
			AutoCurrentAddressDistrict: autoCurrentAddressDistrict,
			AutoCurrentAddressState: autoCurrentAddressState,
			AutoCurrentAddressCountry: autoCurrentAddressCountry,
			AutoCurrentAddressPincode: autoCurrentAddressPincode,

			AutoLoanBankAccNumber: autoLoanBankAccNumber,
			AutoLoanReBankAccNUmber: autoLoanReBankAccNUmber,
			AutoLoanAccHolderName: autoLoanAccHolderName,
			AutoLoanIfscCode: autoLoanIfscCode,
			AutoLoanBankName: autoLoanBankName,
			AutoLoanBankBranchName: autoLoanBankBranchName,
			AutoLoanAltPhone: autoLoanAltPhone,
			AutoLoanBusinessCompany: autoLoanBusinessCompany,
			AutoLoanBusinessDesignation: autoLoanBusinessDesignation,
			AutovehicleInsurancePeriod: autovehicleInsurancePeriod,
			AutoBusinessPremises: autoBusinessPremises,
			AutoNameOfBoard: autoNameOfBoard,
			AutoBankStatementImg: autoBankStatementImg,
			AutoPaySlipImg: autoPaySlipImg,
			AutoApproximateSqft: autoApproximateSqft,
			AutoLoanIdProofFront: autoLoanIdProofFront,
			AutoLoanIdProofBack: autoLoanIdProofBack,
			AutoLoanHouseImage1: autoLoanHouseImage1,
			AutoLoanHouseImage2: autoLoanHouseImage2,
			AutoLoanAddressProofFront: autoLoanAddressProofFront,
			AutoLoanAddressProofBack: autoLoanAddressProofBack,
			AutoLoanPhoto: autoLoanPhoto,
			AutoLoanPermanentAddress: autoLoanPermanentAddress,
			AutoLoanCurrentAddress: autoLoanCurrentAddress,

			AutoCoapplicantName: autoCoapplicantName,
			AutoCoapplicantMobileNo: autoCoapplicantMobileNo,
			AutoCoapplicantDOB: autoCoapplicantDOB,
			AutoCoapplicantGender: autoCoapplicantGender,
			AutoCoapplicantRelationWithMember: autoCoapplicantRelationWithMember,
			AutoCoapplicantAddress: autoCoapplicantAddress,
			AutoCoapplicantDoorNo: autoCoapplicantDoorNo,
			AutoCoapplicantCity: autoCoapplicantCity,
			AutoCoapplicantDistrct: autoCoapplicantDistrct,
			AutoCoapplicantState: autoCoapplicantState,
			AutoCoapplicantCountry: autoCoapplicantCountry,
			AutoCoapplicantPincode: autoCoapplicantPincode,
			AutoCoapplicantMemberImg: autoCoapplicantMemberImg,
			AutoCoapplicantAadharFrontImg: autoCoapplicantAadharFrontImg,
			AutoCoapplicantAadharBackImg: autoCoapplicantAadharBackImg,
			AutoCoapplicantHouseEbBillImg: autoCoapplicantHouseEbBillImg,
			AutoCoapplicantHouseGasBillImg: autoCoapplicantHouseGasBillImg,
			AutoCoapplicantAddressProofFrontImg: autoCoapplicantAddressProofFrontImg,
			AutoCoapplicantAddressProofBackImg: autoCoapplicantAddressProofBackImg,

			AutoLoanMakerName: autoLoanMakerName,
			AutoLoanYearOfManufacture: autoLoanYearOfManufacture,
			AutoLoanOwnershipType: autoLoanOwnershipType,
			AutoLoanVehicleType: autoLoanVehicleType,
			AutoLoanVehicleName: autoLoanVehicleName,
			AutoLoanVehicleCC: autoLoanVehicleCC,
			AutoLoanVehicleColor: autoLoanVehicleColor,
			AutoLoanVehicleCondition: autoLoanVehicleCondition,
			AutoLoanNumberOfOwnership: autoLoanNumberOfOwnership,
			AutoLoanVehicleKeySurrender: autoLoanVehicleKeySurrender,
			AutoLoanRcBookSurrender: autoLoanRcBookSurrender,
			AutoLoanRcBookSurrenderType: autoLoanRcBookSurrenderType,
			AutoLoanRegistrationState: autoLoanRegistrationState,
			AutoLoanRegistrationCity: autoLoanRegistrationCity,
			AutoLoanRegistrationDate: autoLoanRegistrationDate,
			AutoLoanRegistrationNumber: autoLoanRegistrationNumber,
			AutoLoanEngineNumber: autoLoanEngineNumber,
			AutoLoanChassisNumber: autoLoanChassisNumber,
			AutoLoanInsuranceType: autoLoanInsuranceType,
			autoLoanInsuranceFee: autoLoanInsuranceFee,
			autoLoanInsurancePeriod: autoLoanInsurancePeriod,
			autoLoanMemberType: autoLoanMemberType,
			autoLoanCompanyName: autoLoanCompanyName,
			autoLoanDesignation: autoLoanDesignation,
			autoLoanYearsWorking: autoLoanYearsWorking,
			autoLoanIncomeType: autoLoanIncomeType,
			autoLoanBusinessIncome: autoLoanBusinessIncome,
			autoLoanPaySlipImage: autoLoanPaySlipImage,
			autoLoanEmployeeIdCardImage: autoLoanEmployeeIdCardImage,
			autoLoanBusinessPassBook: autoLoanBusinessPassBook,
			autoLoanBusinessPremises: autoLoanBusinessPremises,
			autoLoanApproximateSqft: autoLoanApproximateSqft,
			autoLoanRegisteredSince: autoLoanRegisteredSince,
			autoLoanNumberOfFloors: noOfFlors,
			autoLoanNameOfBoard: autoLoanNameOfBoard,
			autoLoanBusinessStock: autoLoanBusinessStock,
			autoLoanBusinessAddress: autoLoanBusinessAddress,
			autoLoanBusinessBoard: autoLoanBusinessBoard,
			autoLoanShopOrCompany: autoLoanShopOrCompany,

			AutoLoanVehicleNumberPlateImg: autoLoanVehicleNumberPlateImg,
			AutoLoanVehicleNumberFrontImg: autoLoanVehicleNumberFrontImg,
			AutoLoanVehicleLeftSideImg: autoLoanVehicleLeftSideImg,
			AutoLoanVehicleRighitSideImg: autoLoanVehicleRighitSideImg,
			AutoLoanVehicleBackSideImg: autoLoanVehicleBackSideImg,
			AutoLoanVehicleFrontSideImg: autoLoanVehicleFrontSideImg,
			AutoLoanVehicleFrontSidePlateImg: autoLoanVehicleFrontSidePlateImg,
			AutoLoanVehicleRCBookFrontImg: autoLoanVehicleRCBookFrontImg,
			AutoLoanVehicleRCBookBackImg: autoLoanVehicleRCBookBackImg,
			AutoLoanVehicleKeyImg: autoLoanVehicleKeyImg,
			AutoLoanVehicleKMReadingImg: autoLoanVehicleKMReadingImg,
			AutoChassisNumberImage: autoChassisNumberImage,
			AutoEngineNumberImage: autoEngineNumberImage,
			AutoNOCImage1: autoNOCImage1,
			AutoNOCImage2: autoNOCImage2,
			AutoTOImage1: autoTOImage1,
			AutoTOImage2: autoTOImage2,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateMandatoryMemberAccessType, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateMemberMandatoryAccessFailure(responseData.data));
		} else {
			yield put(updateMemberMandatoryAccessSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateMemberMandatoryAccessFailure(error));
	}
}

export function* resetUpdateMemberMandatoryAccessResponse() {
	yield put(updateMemberMandatoryAccessResponseChanged());
}

export function* onUpdateMemberMandatoryAccess() {
	yield takeLatest(
		MemberMandatoryAccessActionTypes.UPDATE_MEMBER_MANDATORY_ACCESS_START,
		updateMemberMandatoryAccessList,
	);
}

export function* onUpdateMemberMandatoryAccessResponseReset() {
	yield takeLatest(
		MemberMandatoryAccessActionTypes.UPDATE_MEMBER_MANDATORY_ACCESS_RESPONSE_RESET,
		resetUpdateMemberMandatoryAccessResponse,
	);
}

/** *********************  END UPDATE MemberMandatory DETAILS LIST ******************** */

export function* memberMandatoryAccessMasterSaga() {
	yield all([
		call(onFetchListMemberMandatoryAccess),
		call(onFetchListMemberMandatoryAccessResponseReset),
		call(onUpdateMemberMandatoryAccess),
		call(onUpdateMemberMandatoryAccessResponseReset),
	]);
}
